import { jsx } from "react/jsx-runtime";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { validateTidalLicense } from "../../base/index.js";
function DragHandle(props) {
  return /* @__PURE__ */ jsx(
    DragHandleIcon,
    {
      "data-testid": "DragHandle",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DragHandle",
      "data-tidal-icon-meta": "layout"
    }
  );
}
DragHandle.tidalIconMeta = {
  categories: "layout",
  name: "DragHandle"
};
validateTidalLicense();
export {
  DragHandle
};
//# sourceMappingURL=DragHandle.js.map
